export default "__VITE_ASSET__DH14qA00__"